import {
  normalizeSessionSttConfig,
  type SessionSttConfig,
  type SttProviderKeyState,
} from "../../shared/sttConfig.ts";

export function liveSttConfigForCapture(
  current: SessionSttConfig,
  providerKeys: SttProviderKeyState,
  ingressSharedSecretConfigured: boolean,
): SessionSttConfig | null {
  if (current.mode !== "disabled") return null;
  if (!ingressSharedSecretConfigured) return null;
  if (!providerKeys[current.provider]) return null;
  return normalizeSessionSttConfig({
    ...current,
    mode: "live",
  });
}
